var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pt-2 pb-4 px-3",attrs:{"color":_vm.color,"outlined":""}},[_c('div',[_c('small',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.title))])]),_c('div',[_c('strong',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }